import { MobileApp } from "./MobileApp";
import { DesktopApp } from "./DesktopApp";

interface AppLayoutProps {
	showNav?: boolean;
}

export function AppLayout({ showNav = true }: AppLayoutProps) {
	if (window.innerWidth >= 500) {
		return <DesktopApp showNav={showNav} />;
	} else {
		return <MobileApp showNav={showNav} />;
	}
}
